module.exports = __webpack_public_path__ + "static/img/banner.0828d9bf.jpg";